const FILTERABLE_USERS_URL = '/orders/filterable-users';
const CARRIERS_URL = 'carriers/associated';
const CARRIER_SERVICES_URL = 'carriers/user/services';
const MASTER_ITEMS_LIST_URL = 'master-items/list';
const ORDERS_SEARCH_URL = 'orders/search-from-splitted-conditions2';
const SYNC_CONDITIONS_VALUES_URL = 'sync-conditions/values';
const UPDATING_RULES_SEARCH_URL = 'updating-rules/search';
const UPDATING_RULES_GENERATE_URL = 'updating-rules/generate';
const UPDATING_RULES_FIELDS_URL = 'updating-rules/fields';
const UPDATING_RULES_INSTANCES_SEARCH_URL = 'updating-rules/instances-search';
const UPDATING_RULES_TEST_URL = 'updating-rules/test';
const UPDATING_RULES_CREATE_URL = 'updating-rules/create';
const UPDATING_RULES_UPDATE_URL = 'updating-rules/update';
const UPDATING_RULES_DELETE_URL = 'updating-rules/delete';
const UPDATING_RULES_GET_VERSIONS_URL = 'updating-rules/get-versions';

const RESOURCE_TYPES = {
    ORDERS: 'ORDERS',
    MASTER_ITEMS: 'MASTER_ITEMS',
};

const ACCORDION_SECTION_TRIGGER_CLASS_NAME =
    'py-3 text-xs font-semibold tracking-wide text-gray-400 uppercase hover:no-underline';

const RULES_LIST_PATH = '/automations/automatic-data-completion/';
const NEW_RULE_PATH = '/automations/automatic-data-completion/new/';

const getEditRulePath = (ruleId) => `/automations/automatic-data-completion/${ruleId}/edit/`;
const getRuleViewPath = (ruleId) => `${RULES_LIST_PATH}?ruleId=${ruleId}`;

export {
    ACCORDION_SECTION_TRIGGER_CLASS_NAME,
    CARRIERS_URL,
    CARRIER_SERVICES_URL,
    FILTERABLE_USERS_URL,
    MASTER_ITEMS_LIST_URL,
    NEW_RULE_PATH,
    ORDERS_SEARCH_URL,
    RESOURCE_TYPES,
    RULES_LIST_PATH,
    SYNC_CONDITIONS_VALUES_URL,
    UPDATING_RULES_CREATE_URL,
    UPDATING_RULES_DELETE_URL,
    UPDATING_RULES_FIELDS_URL,
    UPDATING_RULES_GENERATE_URL,
    UPDATING_RULES_GET_VERSIONS_URL,
    UPDATING_RULES_INSTANCES_SEARCH_URL,
    UPDATING_RULES_SEARCH_URL,
    UPDATING_RULES_TEST_URL,
    UPDATING_RULES_UPDATE_URL,
    getEditRulePath,
    getRuleViewPath,
};
